import * as React from "react";
import {IChannelOperatorListProps} from "./~types/ChannelOperatorListProps";
import IChannelOperatorListState from "./~types/ChannelOperatorListState";
import { Avatar, AvatarGroup } from '@mui/material';
import OperatorIcon from '@mui/icons-material/SupportAgent'

import './ChannelOperatorList.css';
import ChannelOperatorListConfiguration from "./channel-operator-list-configuration/ChannelOperatorListConfiguration";
import i18n from "src/app/shared/localization/i18n";
import { GET_FILE_BY_ID_API_ROUTE } from "src/app/chats-panel/~api/apiRoutes";
import { IOperator } from "src/app/operator/~store/models/Operator";

export default class ChannelOperatorList extends React.Component<IChannelOperatorListProps, IChannelOperatorListState> {
    public readonly state: IChannelOperatorListState = {
        channelOperators: this.props.channelOperators,
        isChannelOperatorsConfigOpen: false,
        maxVisibleOperators: 10,
    };

    private containerRef = React.createRef<HTMLDivElement>();

    public componentDidMount() {
        this._calculateMaxVisibleOperators();
        window.addEventListener('resize', this._calculateMaxVisibleOperators);
    }

    public componentWillUnmount() {
        window.removeEventListener('resize', this._calculateMaxVisibleOperators);
    }

    private _calculateMaxVisibleOperators = (): void => {
        const container = this.containerRef.current;
        if (!container) return;

        const ITEM_WIDTH = 105;
        const BUTTON_WIDTH = 80;

        const maxVisibleOperators = Math.max(
            1,
            Math.floor((container.offsetWidth - BUTTON_WIDTH) / ITEM_WIDTH)
        );

        if (this.state.maxVisibleOperators !== maxVisibleOperators) {
            this.setState({ maxVisibleOperators });
        }
    };

    public render() {
        const {allOperatorsShort} = this.props;
        const {
            isChannelOperatorsConfigOpen,
            channelOperators
        } = this.state
        return (
            <div className="channel-operator-list">
                <div className="channel-operator-list__title">{i18n.t('common.operators') + ":"}</div>
                {this._getChannelOperatorList()}
                <ChannelOperatorListConfiguration 
                    isChannelOperatorsConfigOpen={isChannelOperatorsConfigOpen}
                    channelOperators={channelOperators}
                    allOperatorsShort={allOperatorsShort}
                    channelId={this.props.channelId}
                    onCloseChannelOperatorsConfig={this._toggleChannelOperatorsConfig}
                    onSaveChannelOperators={this.props.onSaveChannelOperators} />
            </div>
        );
    }

    private _getChannelOperatorList = (): React.ReactElement<{}> => {
        const {allOperatorsShort} = this.props;
        const {channelOperators} = this.state;
        const {maxVisibleOperators} = this.state;
        return (
            <div
                className="channel-operator-list__operators"
                ref={this.containerRef}
                style={{ width: '100%' }}
            >
                <AvatarGroup max={maxVisibleOperators}>
                {channelOperators.map((channelOperator, index) => {
                    const operator: IOperator = allOperatorsShort.find(
                        op => op.operatorId === channelOperator.operatorId
                    ) as IOperator;
                    return this._mapOperatorShortToElement(operator, index);
                })}
                </AvatarGroup>
                <button 
                    className="channel-operator-list__btn-add-operator" 
                    onClick={this._toggleChannelOperatorsConfig}>
                    <i className="material-icons">
                        add
                    </i>
                </button>
            </div>
        );
    };

    private _mapOperatorShortToElement = (operator: IOperator, index: number): React.ReactElement<{}> => {
        const userInStorage = sessionStorage.getItem("user");
        const customerId = userInStorage === null ? "" : JSON.parse(userInStorage.toString()).customerId;
        const imageUrl: string =
            (operator?.avatarId === null || operator?.avatarId === undefined)
                ? ''
                : GET_FILE_BY_ID_API_ROUTE + operator.avatarId;

        return (
            <div 
                key={index} 
                className="channel-operator-list__operator"
                onClick={this._toggleChannelOperatorsConfig}>
                <Avatar className="channel-operator-list__operator-avatar" src={imageUrl}>
                    <OperatorIcon style={{ color: '#26a69a'}} />
                </Avatar>
                <div className="channel-operator-list__operator-name">{operator.name}</div>
            </div>
        );
    };

    private _toggleChannelOperatorsConfig = (): void => {
        const isChannelOperatorsConfigOpen = !this.state.isChannelOperatorsConfigOpen;
        this.setState({isChannelOperatorsConfigOpen});
    }
}
